/* eslint-disable */
import { CMS_PREFIX_LIST } from "./cmsPrefix";
import { mapToCopyFileShared } from "./mapToCopyFileShared";

const baseUrlCare = CMS_PREFIX_LIST["care"];
const baseUrlSession = CMS_PREFIX_LIST["session"];

const mapToCopyFileCare = (copy: Record<string, string>) => {
  const getCopyValue = (key: string) => copy?.[key] ?? " ";

  const sharedStories = mapToCopyFileShared(copy);

  return {
    errorFallback: {
      dialog: {
        title: getCopyValue(`${baseUrlSession}/errorfallback/dialog/title`),
        description: getCopyValue(`${baseUrlSession}/errorfallback/dialog/description`),
        reloadButton: getCopyValue(`${baseUrlSession}/errorfallback/dialog/reloadbutton`),
      },
      cameraPermissions: {
        browser: {
          title: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/browser/title`),
          description: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/browser/description`),
          buttonText: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/browser/button-text`),
          faqUrlText: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/browser/faq-url-text`),
        },
        desktop: {
          title: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/desktop/title`),
          description: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/desktop/description`),
          buttonText: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/desktop/button-text`),
          faqUrlText: getCopyValue(`${baseUrlSession}/errorfallback/camera-permissions/desktop/faq-url-text`),
        },
      },
      toast: {
        title: getCopyValue(`${baseUrlSession}/errorfallback/toast/title`),
        description: getCopyValue(`${baseUrlSession}/errorfallback/toast/description`),
        unhandledError: getCopyValue(`${baseUrlSession}/errorfallback/toast/unhandlederror`),
      },
    },
    shared: {
      // @ TODO move this at top when all stories will be moved to shared.
      ...sharedStories.shared,
      comingSoonLabel: getCopyValue(`${baseUrlCare}/shared/comingsoonlabel`),
      painful: getCopyValue(`${baseUrlCare}/shared/painful`),
      medicalIdentifier: getCopyValue(`${baseUrlCare}/shared/medicalidentifier`),
      supportEmail: getCopyValue(`${baseUrlCare}/shared/supportemail`),
      weekDayShort: {
        Mon: getCopyValue(`${baseUrlCare}/shared/weekdayshort/mon`),
        Tue: getCopyValue(`${baseUrlCare}/shared/weekdayshort/tue`),
        Wed: getCopyValue(`${baseUrlCare}/shared/weekdayshort/wed`),
        Thu: getCopyValue(`${baseUrlCare}/shared/weekdayshort/thu`),
        Fri: getCopyValue(`${baseUrlCare}/shared/weekdayshort/fri`),
        Sat: getCopyValue(`${baseUrlCare}/shared/weekdayshort/sat`),
        Sun: getCopyValue(`${baseUrlCare}/shared/weekdayshort/sun`),
      },
      units: {
        days: getCopyValue(`${baseUrlCare}/shared/units/days`),
        seconds: getCopyValue(`${baseUrlCare}/shared/units/seconds`),
        minutes: getCopyValue(`${baseUrlCare}/shared/units/minutes`),
        hours: getCopyValue(`${baseUrlCare}/shared/units/hours`),
      },
      onlineBooking: getCopyValue(`${baseUrlCare}/shared/onlinebooking`),
      specialities: {
        "sports-physiotherapy": getCopyValue(`${baseUrlCare}/shared/specialities/sports-physiotherapy`),
        "general-physiotherapy": getCopyValue(`${baseUrlCare}/shared/specialities/general-physiotherapy`),
        "pelvic-floor": getCopyValue(`${baseUrlCare}/shared/specialities/pelvic-floor`),
        pediatrics: getCopyValue(`${baseUrlCare}/shared/specialities/pediatrics`),
        "neuromotor-and-sensory": getCopyValue(`${baseUrlCare}/shared/specialities/neuromotor-and-sensory`),
        "internal-organs-and-vessels": getCopyValue(`${baseUrlCare}/shared/specialities/internal-organs-and-vessels`),
        musculoskeletal: getCopyValue(`${baseUrlCare}/shared/specialities/musculoskeletal`),
        "virtual-therapist": getCopyValue(`${baseUrlCare}/shared/specialities/virtual-therapist`),
        geriatric: getCopyValue(`${baseUrlCare}/shared/specialities/geriatric`),
      },
      difficulty: {
        easy: getCopyValue(`${baseUrlCare}/shared/difficulty/easy`),
        medium: getCopyValue(`${baseUrlCare}/shared/difficulty/medium`),
        hard: getCopyValue(`${baseUrlCare}/shared/difficulty/hard`),
      },
      support: {
        email: getCopyValue(`${baseUrlCare}/shared/support/email`),
        phoneNumberGeneralSupport: getCopyValue(`${baseUrlCare}/shared/support/phone-number-general-support`),
      },
      exercises: getCopyValue(`${baseUrlCare}/shared/exercises`),
    },
    legal: {
      label: getCopyValue(`${baseUrlCare}/legal/label`),
      and: getCopyValue(`${baseUrlCare}/legal/and`),
      termsOfService: getCopyValue(`${baseUrlCare}/legal/termsofservice`),
      privacyPolicy: getCopyValue(`${baseUrlCare}/legal/privacypolicy`),
      button: getCopyValue(`${baseUrlCare}/legal/button`),
      updatedTermsAcceptance: {
        title: getCopyValue(`${baseUrlCare}/legal/updatedtermsacceptance/title`),
        description: getCopyValue(`${baseUrlCare}/legal/updatedtermsacceptance/description`),
        understoodButton: getCopyValue(`${baseUrlCare}/legal/updatedtermsacceptance/understood-button`),
      },
      updatedPrivacyPolicyAcceptance: {
        title: getCopyValue(`${baseUrlCare}/legal/updatedprivacypolicyacceptance/title`),
        description: getCopyValue(`${baseUrlCare}/legal/updatedprivacypolicyacceptance/description`),
        error: getCopyValue(`${baseUrlCare}/legal/updatedprivacypolicyacceptance/error`),
      },
      updatedTermsAndPrivacyPolicyAcceptance: {
        title: getCopyValue(`${baseUrlCare}/legal/updatedtermsandprivacypolicyacceptance/title`),
        description: getCopyValue(`${baseUrlCare}/legal/updatedtermsandprivacypolicyacceptance/description`),
        error: getCopyValue(`${baseUrlCare}/legal/updatedtermsandprivacypolicyacceptance/error`),
      },
    },
    session: {
      loadingText: getCopyValue(`${baseUrlSession}/session/loadingtext`),
      login: { title: getCopyValue(`${baseUrlCare}/session/login/title`) },
      loginCard: {
        buttons: {
          email: getCopyValue(`${baseUrlCare}/session/logincard/buttons/email`),
          register: getCopyValue(`${baseUrlCare}/session/logincard/buttons/register`),
          login: getCopyValue(`${baseUrlCare}/session/logincard/buttons/login`),
        },
      },
      performanceIssues: {
        slowNetworkIssue: getCopyValue(`${baseUrlSession}/session/performance-issues/slow-network-issue`),
        lowBatteryIssue: getCopyValue(`${baseUrlSession}/session/performance-issues/low-battery-issue`),
        lowRAMIssue: getCopyValue(`${baseUrlSession}/session/performance-issues/low-ram-issue`),

        performanceIssuesDialog: {
          title: getCopyValue(`${baseUrlSession}/session/performance-issues/performance-issues-dialog/title`),
          description: getCopyValue(
            `${baseUrlSession}/session/performance-issues/performance-issues-dialog/description`,
          ),
          checkboxLabel: getCopyValue(
            `${baseUrlSession}/session/performance-issues/performance-issues-dialog/checkbox-label`,
          ),
          button: getCopyValue(`${baseUrlSession}/session/performance-issues/performance-issues-dialog/button`),
        },
      },
      hoverStates: {
        increaseVolume: getCopyValue(`${baseUrlSession}/session/hoverstates/increasevolume`),
        decreaseVolume: getCopyValue(`${baseUrlSession}/session/hoverstates/decreasevolume`),
        skipSong: getCopyValue(`${baseUrlSession}/session/hoverstates/skipsong`),
        mute: getCopyValue(`${baseUrlSession}/session/hoverstates/mute`),
        back: getCopyValue(`${baseUrlSession}/session/hoverstates/back`),
        exerciseSets: getCopyValue(`${baseUrlSession}/session/hoverstates/exercisesets`),
        exerciseTime: getCopyValue(`${baseUrlSession}/session/hoverstates/exercisetime`),
        exerciseReps: getCopyValue(`${baseUrlSession}/session/hoverstates/exercisereps`),
        pause: getCopyValue(`${baseUrlSession}/session/hoverstates/pause`),
        switchVideo: getCopyValue(`${baseUrlSession}/session/hoverstates/switchvideo`),
        play: getCopyValue(`${baseUrlSession}/session/hoverstates/play`),
        skipExercise: getCopyValue(`${baseUrlSession}/session/hoverstates/skipexercise`),
        exitSession: getCopyValue(`${baseUrlSession}/session/hoverstates/exitsession`),
        settings: getCopyValue(`${baseUrlSession}/session/hoverstates/settings`),
        exerciseInstruction: getCopyValue(`${baseUrlSession}/session/hoverstates/exerciseinstruction`),
        volume: getCopyValue(`${baseUrlSession}/session/hoverstates/volume`),
        skipInstructions: getCopyValue(`${baseUrlSession}/session/hoverstates/skipinstructions`),
      },
      fullScreenLayout: {
        goFullScreen: getCopyValue(`${baseUrlSession}/session/fullscreenlayout/gofullscreen`),
        exitFullScreen: getCopyValue(`${baseUrlSession}/session/fullscreenlayout/exitfullscreen`),
        title: getCopyValue(`${baseUrlSession}/session/fullscreenlayout/title`),
        text: getCopyValue(`${baseUrlSession}/session/fullscreenlayout/text`),
        checkboxText: getCopyValue(`${baseUrlSession}/session/fullscreenlayout/checkboxtext`),
        fullScreenButton: getCopyValue(`${baseUrlSession}/session/fullscreenlayout/fullscreenbutton`),
        skipButton: getCopyValue(`${baseUrlSession}/session/fullscreenlayout/skipbutton`),
      },
      loadingModelText: getCopyValue(`${baseUrlSession}/session/loadingmodeltext`),
      loadingModelTextSlow: getCopyValue(`${baseUrlSession}/session/loadingmodeltextslow`),
      setup: {
        activateCameraDialog: {
          title: getCopyValue(`${baseUrlSession}/session/setup/activatecameradialog/title`),
          description: getCopyValue(`${baseUrlSession}/session/setup/activatecameradialog/description`),
          cameraText: getCopyValue(`${baseUrlSession}/session/setup/activatecameradialog/cameratext`),
          buttonText: getCopyValue(`${baseUrlSession}/session/setup/activatecameradialog/buttontext`),
        },
        noAccessDialog: {
          title: getCopyValue(`${baseUrlSession}/session/setup/noaccessdialog/title`),
          browserDescription: getCopyValue(`${baseUrlSession}/session/setup/noaccessdialog/browserdescription`),
          buttonText: getCopyValue(`${baseUrlSession}/session/setup/noaccessdialog/buttontext`),
        },
        cameraError: {
          title: getCopyValue(`${baseUrlSession}/session/setup/cameraerror/title`),
          description: getCopyValue(`${baseUrlSession}/session/setup/cameraerror/description`),
          buttonText: getCopyValue(`${baseUrlSession}/session/setup/cameraerror/buttontext`),
        },
        cameraPositioningMessages: {
          initial: getCopyValue(`${baseUrlSession}/session/setup/camerapositioningmessages/initial`),
          tooFarRight: getCopyValue(`${baseUrlSession}/session/setup/camerapositioningmessages/toofarright`),
          tooFarLeft: getCopyValue(`${baseUrlSession}/session/setup/camerapositioningmessages/toofarleft`),
          wholeBodyVisible: getCopyValue(`${baseUrlSession}/session/setup/camerapositioningmessages/wholebodyvisible`),
          notDetected: getCopyValue(`${baseUrlSession}/session/setup/camerapositioningmessages/notdetected`),
          tooDark: getCopyValue(`${baseUrlSession}/session/setup/camerapositioningmessages/toodark`),
          stayThere: getCopyValue(`${baseUrlSession}/session/setup/camerapositioningmessages/staythere`),
        },
        success: {
          title: getCopyValue(`${baseUrlSession}/session/setup/success/title`),
        },
        motionSetup: {
          title: getCopyValue(`${baseUrlSession}/session/setup/motionsetup/title`),
        },
        cameraSetup: {
          camera: getCopyValue(`${baseUrlSession}/session/setup/camerasetup/camera`),
        },
      },
      routine: {
        musicLevel: {
          title: getCopyValue(`${baseUrlSession}/session/routine/musiclevel/title`),
        },
        pause: {
          willCancel: getCopyValue(`${baseUrlSession}/session/routine/pause/willcancel`),
          skipDialog: {
            title: getCopyValue(`${baseUrlSession}/session/routine/pause/skipdialog/title`),
            confirm: getCopyValue(`${baseUrlSession}/session/routine/pause/skipdialog/confirm`),
            cancel: getCopyValue(`${baseUrlSession}/session/routine/pause/skipdialog/cancel`),
          },
          cancelDialog: {
            title: getCopyValue(`${baseUrlSession}/session/routine/pause/canceldialog/title`),
            confirm: getCopyValue(`${baseUrlSession}/session/routine/pause/canceldialog/confirm`),
            cancel: getCopyValue(`${baseUrlSession}/session/routine/pause/canceldialog/cancel`),
          },
        },
        rest: {
          text: getCopyValue(`${baseUrlSession}/session/routine/rest/text`),
          end: getCopyValue(`${baseUrlSession}/session/routine/rest/end`),
        },
        cooldown: {
          text: getCopyValue(`${baseUrlSession}/session/routine/cooldown/text`),
          end: getCopyValue(`${baseUrlSession}/session/routine/cooldown/end`),
          selectionTitle: getCopyValue(`${baseUrlSession}/session/routine/cooldown/selectiontitle`),
          fullLengthDescription: getCopyValue(`${baseUrlSession}/session/routine/cooldown/fulllengthdescription`),
          shortLengthDescription: getCopyValue(`${baseUrlSession}/session/routine/cooldown/shortlengthdescription`),
          fullLength: getCopyValue(`${baseUrlSession}/session/routine/cooldown/fulllength`),
          shortLength: getCopyValue(`${baseUrlSession}/session/routine/cooldown/shortlength`),
          finishDescription: getCopyValue(`${baseUrlSession}/session/routine/cooldown/finishdescription`),
        },
        slowConnectionMessage: getCopyValue(
          `${baseUrlSession}/session/routine/warning-messages/slow-internet-connection-message`,
        ),
        performanceIssueMessage: getCopyValue(
          `${baseUrlSession}/session/routine/warning-messages/performance-issue-message`,
        ),
        maiaAIConnectionIssueMessage: getCopyValue(
          `${baseUrlSession}/session/routine/warning-messages/maia-ai-connection-issue-message`,
        ),
        userInteractionNeededMessage: getCopyValue(
          `${baseUrlSession}/session/routine/warning-messages/user-interaction-needed-message`,
        ),
      },
      settings: {
        toasters: {
          settingsUpdatedSuccess: getCopyValue(`${baseUrlSession}/session/settings/toasters/settingsupdatedsuccess`),
        },
        title: getCopyValue(`${baseUrlSession}/session/settings/title`),
        back: getCopyValue(`${baseUrlSession}/session/settings/back`),
        sidebarTooltip: getCopyValue(`${baseUrlSession}/session/settings/sidebartooltip`),
        sectionGroups: {
          general: getCopyValue(`${baseUrlSession}/session/settings/sectiongroups/general`),
          audio: getCopyValue(`${baseUrlSession}/session/settings/sectiongroups/audio`),
          video: getCopyValue(`${baseUrlSession}/session/settings/sectiongroups/video`),
        },
        sections: {
          language: {
            name: getCopyValue(`${baseUrlSession}/session/settings/sections/language/name`),
            title: getCopyValue(`${baseUrlSession}/session/settings/sections/language/title`),
            subtitle: getCopyValue(`${baseUrlSession}/session/settings/sections/language/subtitle`),
          },
          voice: {
            name: getCopyValue(`${baseUrlSession}/session/settings/sections/voice/name`),
            title: getCopyValue(`${baseUrlSession}/session/settings/sections/voice/title`),
            subtitle: getCopyValue(`${baseUrlSession}/session/settings/sections/voice/subtitle`),
          },
          sound: {
            name: getCopyValue(`${baseUrlSession}/session/settings/sections/sound/name`),
            title: getCopyValue(`${baseUrlSession}/session/settings/sections/sound/title`),
            subtitle: getCopyValue(`${baseUrlSession}/session/settings/sections/sound/subtitle`),
          },
          camera: {
            name: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/name`),
            title: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/title`),
            subtitle: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/subtitle`),
            header: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/header`),
            camera: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/camera`),
            note: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/note`),
            cameraInfo: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/camerainfo`),
            skeletonInfo: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/skeletoninfo`),
            cameraTip: getCopyValue(`${baseUrlSession}/session/settings/sections/camera/cameratip`),
          },
        },
      },
      lateralityTextLeft: getCopyValue(`${baseUrlSession}/session/lateralitytextleft`),
      lateralityTextRight: getCopyValue(`${baseUrlSession}/session/lateralitytextright`),
    },
    settings: {
      toasters: {
        settingsUpdatedSuccess: getCopyValue(`${baseUrlCare}/settings/toasters/settingsupdatedsuccess`),
      },
      sidebar: {
        groups: {
          general: getCopyValue(`${baseUrlCare}/settings/sidebar/groups/general`),
          personalization: getCopyValue(`${baseUrlCare}/settings/sidebar/groups/Personalization`),
        },
        links: {
          account: getCopyValue(`${baseUrlCare}/settings/sidebar/links/account`),
          clinic: getCopyValue(`${baseUrlCare}/settings/sidebar/links/clinic`),
          language: getCopyValue(`${baseUrlCare}/settings/sidebar/links/language`),
          theme: getCopyValue(`${baseUrlCare}/settings/sidebar/links/theme`),
          notification: getCopyValue(`${baseUrlCare}/settings/sidebar/links/notification`),
          voice: getCopyValue(`${baseUrlCare}/settings/sidebar/links/voice`),
          sound: getCopyValue(`${baseUrlCare}/settings/sidebar/links/sound`),
          termsAndConditions: getCopyValue(`${baseUrlCare}/settings/sidebar/links/termsandconditions`),
          ifu: getCopyValue(`${baseUrlCare}/settings/sidebar/links/ifu`),
          dataTransparency: getCopyValue(`${baseUrlCare}/settings/sidebar/links/datatransparency`),
          releaseNotes: getCopyValue(`${baseUrlCare}/settings/sidebar/links/releasenotes`),
        },
      },
      legalPage: {
        version: getCopyValue(`${baseUrlCare}/settings/legalpage/version`),
        download: getCopyValue(`${baseUrlCare}/settings/legalpage/download`),
        tableOfContentsHeadline: getCopyValue(`${baseUrlCare}/settings/legalpage/tableofcontentsheadline`),
        tableOfContentsMultipleLanguages: {
          en: getCopyValue(`${baseUrlCare}/settings/legalpage/table-of-contents-headline-en`),
          de: getCopyValue(`${baseUrlCare}/settings/legalpage/table-of-contents-headline-de`),
          it: getCopyValue(`${baseUrlCare}/settings/legalpage/table-of-contents-headline-it`),
          fr: getCopyValue(`${baseUrlCare}/settings/legalpage/table-of-contents-headline-fr`),
        },
      },
      language: {
        title: getCopyValue(`${baseUrlCare}/settings/language/title`),
        description: getCopyValue(`${baseUrlCare}/settings/language/description`),
      },
      voice: {
        title: getCopyValue(`${baseUrlCare}/settings/voice/title`),
        description: getCopyValue(`${baseUrlCare}/settings/voice/description`),
      },
      clinic: {
        title: getCopyValue(`${baseUrlCare}/settings/clinic/title`),
        prescriptionDetails: {
          title: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/title`),
          subtitle: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/subtitle`),
          ends: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/ends`),
          submitButton: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/submitbutton`),
          noPrescription: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/noprescription`),
          currentPrescription: {
            title: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/currentprescription/title`),
            fields: {
              name: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/currentprescription/fields/name`),
              goal: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/currentprescription/fields/goal`),
              scheduledEndDate: getCopyValue(
                `${baseUrlCare}/settings/clinic/prescriptiondetails/currentprescription/fields/scheduledenddate`,
              ),
            },
            download: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/currentprescription/download`),
            active: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/currentprescription/active`),
            toasters: {
              downloadFailed: getCopyValue(
                `${baseUrlCare}/settings/clinic/prescriptiondetails/currentprescription/toasters/downloadfailed`,
              ),
            },
          },
          resubmitButton: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/resubmitbutton`),
          oldPrescriptions: {
            title: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/oldprescriptions/title`),
            expired: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/oldprescriptions/expired`),
          },
          upload: {
            title: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/upload/title`),
            subtitle: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/upload/subtitle`),
            button: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/upload/button`),
            toasters: {
              sizeLimitExceeded: getCopyValue(
                `${baseUrlCare}/settings/clinic/prescriptiondetails/upload/toasters/sizelimitexceeded`,
              ),
              fileTypeError: getCopyValue(
                `${baseUrlCare}/settings/clinic/prescriptiondetails/upload/toasters/filetypeerror`,
              ),
              uploadFailed: getCopyValue(
                `${baseUrlCare}/settings/clinic/prescriptiondetails/upload/toasters/uploadfailed`,
              ),
              uploadSuccessful: getCopyValue(
                `${baseUrlCare}/settings/clinic/prescriptiondetails/upload/toasters/uploadsuccessful`,
              ),
            },
            dropHere: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/upload/drophere`),
            browse: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/upload/browse`),
            continue: getCopyValue(`${baseUrlCare}/settings/clinic/prescriptiondetails/upload/continue`),
          },
        },
      },
      account: {
        title: getCopyValue(`${baseUrlCare}/settings/account/title`),
        profile: {
          title: getCopyValue(`${baseUrlCare}/settings/account/profile/title`),
          subtitle: getCopyValue(`${baseUrlCare}/settings/account/profile/subtitle`),
          form: {
            firstName: {
              label: getCopyValue(`${baseUrlCare}/settings/account/profile/form/firstname/label`),
              placeholder: getCopyValue(`${baseUrlCare}/settings/account/profile/form/firstname/placeholder`),
              requiredError: getCopyValue(`${baseUrlCare}/settings/account/profile/form/firstname/requirederror`),
            },
            lastName: {
              label: getCopyValue(`${baseUrlCare}/settings/account/profile/form/lastname/label`),
              placeholder: getCopyValue(`${baseUrlCare}/settings/account/profile/form/lastname/placeholder`),
              requiredError: getCopyValue(`${baseUrlCare}/settings/account/profile/form/lastname/requirederror`),
            },
            contactEmail: {
              label: getCopyValue(`${baseUrlCare}/settings/account/profile/form/contactemail/label`),
              placeholder: getCopyValue(`${baseUrlCare}/settings/account/profile/form/contactemail/placeholder`),
              requiredError: getCopyValue(`${baseUrlCare}/settings/account/profile/form/contactemail/requirederror`),
              invalidError: getCopyValue(`${baseUrlCare}/settings/account/profile/form/contactemail/invaliderror`),
            },
            save: getCopyValue(`${baseUrlCare}/settings/account/profile/form/save`),
            toasters: {
              success: getCopyValue(`${baseUrlCare}/settings/account/profile/form/toasters/success`),
              error: getCopyValue(`${baseUrlCare}/settings/account/profile/form/toasters/error`),
            },
          },
          upload: {
            toasters: {
              sizeLimitExceeded: getCopyValue(
                `${baseUrlCare}/settings/account/profile/upload/toasters/sizelimitexceeded`,
              ),
              fileTypeError: getCopyValue(`${baseUrlCare}/settings/account/profile/upload/toasters/filetypeerror`),
              uploadFailed: getCopyValue(`${baseUrlCare}/settings/account/profile/upload/toasters/uploadfailed`),
            },
          },
        },
        password: {
          title: getCopyValue(`${baseUrlCare}/settings/account/password/title`),
          subtitle: getCopyValue(`${baseUrlCare}/settings/account/password/subtitle`),
          button: getCopyValue(`${baseUrlCare}/settings/account/password/button`),
          toasters: {
            success: getCopyValue(`${baseUrlCare}/settings/account/password/toasters/success`),
            error: getCopyValue(`${baseUrlCare}/settings/account/password/toasters/error`),
          },
        },
        closeAccount: {
          title: getCopyValue(`${baseUrlCare}/settings/account/closeaccount/title`),
          subtitle: {
            first: getCopyValue(`${baseUrlCare}/settings/account/closeaccount/subtitle/first`),
            action: getCopyValue(`${baseUrlCare}/settings/account/closeaccount/subtitle/action`),
            actionUrl: getCopyValue(`${baseUrlCare}/settings/account/closeaccount/subtitle/actionurl`),
            last: getCopyValue(`${baseUrlCare}/settings/account/closeaccount/subtitle/last`),
          },
        },
        medicalIdentifier: {
          title: getCopyValue(`${baseUrlCare}/settings/account/medicalidentifier/title`),
          tooltip: getCopyValue(`${baseUrlCare}/settings/account/medicalidentifier/tooltip`),
        },
        prescriptionExpired: {
          title: getCopyValue(`${baseUrlCare}/settings/account/prescriptionexpired/title`),
          description: getCopyValue(`${baseUrlCare}/settings/account/prescriptionexpired/description`),
          contactSupport: getCopyValue(`${baseUrlCare}/settings/account/prescriptionexpired/contact-support`),
        },
        physiotherapistDisconnected: {
          title: getCopyValue(`${baseUrlCare}/settings/account/physiotherapist-disconnected/title`),
          description: getCopyValue(`${baseUrlCare}/settings/account/physiotherapist-disconnected/description`),
          contactSupport: getCopyValue(`${baseUrlCare}/settings/account/physiotherapist-disconnected/contact-support`),
        },
      },
      theme: {
        title: getCopyValue(`${baseUrlCare}/settings/theme/title`),
        description: getCopyValue(`${baseUrlCare}/settings/theme/description`),
      },
      phoneNumberDialog: {
        editPhoneNumberTitle: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/editphonenumbertitle`),
        addPhoneNumberTitle: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/addphonenumbertitle`),
        enterPhoneNumber: {
          title: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/enterphonenumber/title`),
          subtitle: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/enterphonenumber/subtitle`),
          placeholder: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/enterphonenumber/placeholder`),
          required: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/enterphonenumber/required`),
        },
        verify: {
          title: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/verify/title`),
          resendCode: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/verify/resendcode`),
          enterCode: {
            title: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/verify/entercode/title`),
            subtitle: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/verify/entercode/subtitle`),
          },
        },
        continue: getCopyValue(`${baseUrlCare}/settings/phonenumberdialog/continue`),
      },
      notification: {
        title: getCopyValue(`${baseUrlCare}/settings/notification/title`),
        types: {
          accountManagement: getCopyValue(`${baseUrlCare}/settings/notification/types/account-management`),
          physiotherapistUpdates: getCopyValue(`${baseUrlCare}/settings/notification/types/physiotherapist-updates`),
          reminders: getCopyValue(`${baseUrlCare}/settings/notification/types/reminders`),
          productUpdates: getCopyValue(`${baseUrlCare}/settings/notification/types/product-updates`),
        },
        email: {
          title: getCopyValue(`${baseUrlCare}/settings/notification/email/title`),
          subtitle: getCopyValue(`${baseUrlCare}/settings/notification/email/subtitle`),
        },
        text: {
          title: getCopyValue(`${baseUrlCare}/settings/notification/text/title`),
          subtitle: getCopyValue(`${baseUrlCare}/settings/notification/text/subtitle`),
          button: getCopyValue(`${baseUrlCare}/settings/notification/text/button`),
          edit: getCopyValue(`${baseUrlCare}/settings/notification/text/edit`),
        },
        studyParticipation: {
          title: getCopyValue(`${baseUrlCare}/settings/notification/studyparticipation/title`),
          subtitle: getCopyValue(`${baseUrlCare}/settings/notification/studyparticipation/subtitle`),
        },
      },
      sound: {
        title: getCopyValue(`${baseUrlCare}/settings/sound/title`),
        subtitle: getCopyValue(`${baseUrlCare}/settings/sound/subtitle`),
      },
    },
    dashboard: {
      appExecPathDialog: {
        title: getCopyValue(`${baseUrlCare}/dashboard/appexecpathdialog/title`),
        description: getCopyValue(`${baseUrlCare}/dashboard/appexecpathdialog/description`),
        quitButton: getCopyValue(`${baseUrlCare}/dashboard/appexecpathdialog/quitbutton`),
        ignoreButton: getCopyValue(`${baseUrlCare}/dashboard/appexecpathdialog/ignorebutton`),
      },
      banner: {
        outdatedBrowser: {
          headline: getCopyValue(`${baseUrlCare}/dashboard/banner/outdatedbrowser/headline`),
          description: getCopyValue(`${baseUrlCare}/dashboard/banner/outdatedbrowser/description`),
          button: getCopyValue(`${baseUrlCare}/dashboard/banner/outdatedbrowser/button`),
        },
        unsupportedBrowser: {
          headline: getCopyValue(`${baseUrlCare}/dashboard/banner/unsupportedbrowser/headline`),
          description: getCopyValue(`${baseUrlCare}/dashboard/banner/unsupportedbrowser/description`),
          button: getCopyValue(`${baseUrlCare}/dashboard/banner/unsupportedbrowser/button`),
        },
        downloadDesktopApp: {
          headline: getCopyValue(`${baseUrlCare}/dashboard/banner/downloaddesktopapp/headline`),
          description: getCopyValue(`${baseUrlCare}/dashboard/banner/downloaddesktopapp/description`),
          button: getCopyValue(`${baseUrlCare}/dashboard/banner/downloaddesktopapp/button`),
        },
      },
      analysis: {
        weeklyProgress: {
          title: getCopyValue(`${baseUrlCare}/dashboard/analysis/weeklyprogress/title`),
          monthlyActivityTitle: getCopyValue(`${baseUrlCare}/dashboard/analysis/weeklyprogress/monthly-activity-title`),
          weeklyActivityTitle: getCopyValue(`${baseUrlCare}/dashboard/analysis/weeklyprogress/weekly-activity-title`),
          totalTrainingTimeTitle: getCopyValue(
            `${baseUrlCare}/dashboard/analysis/weeklyprogress/total-training-time-title`,
          ),
          numberMoreSessions: getCopyValue(`${baseUrlCare}/dashboard/analysis/weeklyprogress/number-more-sessions`),
          numberWeeksOnTrack: getCopyValue(`${baseUrlCare}/dashboard/analysis/weeklyprogress/number-weeks-on-track`),
          calendarLegendCompletedLabel: getCopyValue(
            `${baseUrlCare}/dashboard/analysis/weeklyprogress/calendar-legend-completed-label`,
          ),
          calendarLegendNoSessionLabel: getCopyValue(
            `${baseUrlCare}/dashboard/analysis/weeklyprogress/calendar-legend-no-session-label`,
          ),
          topPercent: getCopyValue(`${baseUrlCare}/dashboard/analysis/weeklyprogress/top-percent`),
        },
        bothSidesTooltip: getCopyValue(`${baseUrlCare}/dashboard/analysis/both-sides-only-tooltip`),
        oneSideOnlyTooltip: getCopyValue(`${baseUrlCare}/dashboard/analysis/one-side-only-tooltip`),
      },
      today: {
        greetings: {
          morning: getCopyValue(`${baseUrlCare}/dashboard/today/greetings/morning`),
          day: getCopyValue(`${baseUrlCare}/dashboard/today/greetings/day`),
          evening: getCopyValue(`${baseUrlCare}/dashboard/today/greetings/evening`),
        },
        headline: getCopyValue(`${baseUrlCare}/dashboard/today/headline`),
        duration: getCopyValue(`${baseUrlCare}/dashboard/today/duration`),
        materials: getCopyValue(`${baseUrlCare}/dashboard/today/materials`),
        startButton: getCopyValue(`${baseUrlCare}/dashboard/today/startbutton`),
        ptAssigned: {
          congratulations: getCopyValue(`${baseUrlCare}/dashboard/today/ptassigned/congratulations`),
          approvedText: getCopyValue(`${baseUrlCare}/dashboard/today/ptassigned/approvedtext`),
          therapist: {
            title: getCopyValue(`${baseUrlCare}/dashboard/today/ptassigned/therapist/title`),
            subtitle: getCopyValue(`${baseUrlCare}/dashboard/today/ptassigned/therapist/subtitle`),
          },
          button: getCopyValue(`${baseUrlCare}/dashboard/today/ptassigned/button`),
        },
        happinessFeedback: {
          headline: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/headline`),
          submitButton: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/submit-button`),
          textAreaPlaceholder: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/text-area-placeholder`),
          ratings: {
            veryPoor: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/ratings/very-poor`),
            poor: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/ratings/poor`),
            acceptable: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/ratings/acceptable`),
            good: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/ratings/good`),
            veryGood: getCopyValue(`${baseUrlCare}/dashboard/today/happiness-feedback/ratings/very-good`),
          },
        },
      },
      therapyPlan: {
        details: {
          title: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/title`),
          therapyPlan: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/therapyplan`),
          started: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/started`),
          scheduledEndDate: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/scheduledenddate`),
          goal: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/goal`),
          madeBy: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/madeby`),
          freelancePT: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/freelancept`),
          clinicPT: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/details/clinicpt`),
        },
        phases: {
          title: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/phases/title`),
          card: {
            now: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/phases/card/now`),
            title: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/phases/card/title`),
            week: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/phases/card/week`),
          },
        },
        questions: {
          title: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/questions/title`),
          viewMore: {
            url: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/questions/viewmore/url`),
            text: getCopyValue(`${baseUrlCare}/dashboard/therapyplan/questions/viewmore/text`),
          },
        },
      },
      navigationBar: {
        menu: {
          today: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/menu/today`),
          shorts: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/menu/shorts`),
          analysis: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/menu/analysis`),
          therapyPlan: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/menu/therapyplan`),
        },
        profileMenu: {
          accountSettings: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/profilemenu/accountsettings`),
          support: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/profilemenu/support`),
          ifu: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/profilemenu/ifu`),
          logOut: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/profilemenu/logout`),
        },
        notificationsMenu: {
          headline: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/notificationsmenu/headline`),
          markAllAsRead: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/notificationsmenu/markallasread`),
          emptyState: {
            title: getCopyValue(`${baseUrlCare}/dashboard/navigationbar/notificationsmenu/emptystate/title`),
            description: getCopyValue(
              `${baseUrlCare}/dashboard/navigationbar/notificationsmenu/emptystate/description`,
            ),
          },
        },
      },
    },
    onboarding: {
      consultPhysicianDialog: {
        title: getCopyValue(`${baseUrlCare}/onboarding/consultphysiciandialog/title`),
        subtitle: getCopyValue(`${baseUrlCare}/onboarding/consultphysiciandialog/subtitle`),
        leaveButton: {
          text: getCopyValue(`${baseUrlCare}/onboarding/consultphysiciandialog/leavebutton/text`),
          url: getCopyValue(`${baseUrlCare}/onboarding/consultphysiciandialog/leavebutton/url`),
        },
        goBackButton: getCopyValue(`${baseUrlCare}/onboarding/consultphysiciandialog/gobackbutton`),
      },
      redirectingToApp: {
        redirectingTitle: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/redirecting-title`),

        noAppYet: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/no-app-yet`),
        downloadHere: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/download-here`),

        tryAgain: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/try-again`),
        clickHere: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/click-here`),
        openOnLaptop: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/open-on-laptop`),
        continueOnWebUrl: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/continue-on-web-url`),
        continueOnWeb: getCopyValue(`${baseUrlCare}/onboarding/redirecting-to-app/continue-on-web`),
      },
      codeActivation: {
        title: getCopyValue(`${baseUrlCare}/onboarding/code-activation/title`),
        description: getCopyValue(`${baseUrlCare}/onboarding/code-activation/description`),
        invalidCode: getCopyValue(`${baseUrlCare}/onboarding/code-activation/invalid-code`),
        continue: getCopyValue(`${baseUrlCare}/onboarding/code-activation/continue`),
      },
      layout: {
        helpDialog: {
          title: getCopyValue(`${baseUrlCare}/onboarding/layout/helpdialog/title`),
          text: getCopyValue(`${baseUrlCare}/onboarding/layout/helpdialog/text`),
          button: {
            text: getCopyValue(`${baseUrlCare}/onboarding/layout/helpdialog/button/text`),
            url: getCopyValue(`${baseUrlCare}/onboarding/layout/helpdialog/button/url`),
          },
        },
        help: getCopyValue(`${baseUrlCare}/onboarding/layout/help`),
        back: getCopyValue(`${baseUrlCare}/onboarding/layout/back`),
        continue: getCopyValue(`${baseUrlCare}/onboarding/layout/continue`),
        progressBar: {
          prescriptionUpload: getCopyValue(`${baseUrlCare}/onboarding/layout/progressbar/prescriptionupload`),
          personalization: getCopyValue(`${baseUrlCare}/onboarding/layout/progressbar/personalization`),
          institution: getCopyValue(`${baseUrlCare}/onboarding/layout/progressbar/institution`),
          therapist: getCopyValue(`${baseUrlCare}/onboarding/layout/progressbar/therapist`),
          account: getCopyValue(`${baseUrlCare}/onboarding/layout/progressbar/account`),
          therapy: getCopyValue(`${baseUrlCare}/onboarding/layout/progressbar/therapy`),
        },
      },
      confirmEmail: {
        title: getCopyValue(`${baseUrlCare}/onboarding/confirm-email/title`),
        emailLabel: getCopyValue(`${baseUrlCare}/onboarding/confirm-email/email-label`),
        passwordLabel: getCopyValue(`${baseUrlCare}/onboarding/confirm-email/password-label`),
        passwordPlaceholder: getCopyValue(`${baseUrlCare}/onboarding/confirm-email/password-placeholder`),
      },
      form: {
        dateOfBirth: {
          ageBoundaries: getCopyValue(`${baseUrlCare}/onboarding/form/dateofbirth/ageBoundaries`),
        },
        privacyRequired: getCopyValue(`${baseUrlCare}/onboarding/form/privacy/privacyRequired`),
        password: {
          threeOfTheFollowing: getCopyValue(`${baseUrlCare}/onboarding/form/password/three-of-the-following`),
          minLength: getCopyValue(`${baseUrlCare}/onboarding/form/password/min-length`),
          upperCase: getCopyValue(`${baseUrlCare}/onboarding/form/password/upper-case`),
          lowerCase: getCopyValue(`${baseUrlCare}/onboarding/form/password/lower-case`),
          specialCharacter: getCopyValue(`${baseUrlCare}/onboarding/form/password/special-character`),
          number: getCopyValue(`${baseUrlCare}/onboarding/form/password/number`),
        },
      },
      registration: {
        title: getCopyValue(`${baseUrlCare}/onboarding/registration/title`),
        subtitle: getCopyValue(`${baseUrlCare}/onboarding/registration/subtitle`),
      },
      success: {
        title: getCopyValue(`${baseUrlCare}/onboarding/success/title`),
        subtitle: getCopyValue(`${baseUrlCare}/onboarding/success/subtitle`),
        button: getCopyValue(`${baseUrlCare}/onboarding/success/button`),
      },
      verify: {
        title: getCopyValue(`${baseUrlCare}/onboarding/verify/title`),
        subtitle: getCopyValue(`${baseUrlCare}/onboarding/verify/subtitle`),
        secondSubtitle: getCopyValue(`${baseUrlCare}/onboarding/verify/secondsubtitle`),
        resendVerificationButton: getCopyValue(`${baseUrlCare}/onboarding/verify/resendverificationbutton`),
        resendVerificationButtonWithTimer: getCopyValue(
          `${baseUrlCare}/onboarding/verify/resendverificationbuttonwithtimer`,
        ),
        toasters: {
          resendSuccess: getCopyValue(`${baseUrlCare}/onboarding/verify/toasters/resendsuccess`),
        },
      },
      welcome: {
        title: getCopyValue(`${baseUrlCare}/onboarding/welcome/title`),
        subtitle: getCopyValue(`${baseUrlCare}/onboarding/welcome/subtitle`),
        no: getCopyValue(`${baseUrlCare}/onboarding/welcome/no`),
        yes: getCopyValue(`${baseUrlCare}/onboarding/welcome/yes`),
        privacy: {
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/welcome/privacy/subtitle`),
          title: getCopyValue(`${baseUrlCare}/onboarding/welcome/privacy/title`),
          termsAndPrivacyCheckbox: {
            label: getCopyValue(`${baseUrlCare}/onboarding/welcome/privacy/termsandprivacycheckbox/label`),
            and: getCopyValue(`${baseUrlCare}/onboarding/welcome/privacy/termsandprivacycheckbox/and`),
            termsOfService: {
              text: getCopyValue(
                `${baseUrlCare}/onboarding/welcome/privacy/termsandprivacycheckbox/termsofservice/text`,
              ),
              url: getCopyValue(`${baseUrlCare}/onboarding/welcome/privacy/termsandprivacycheckbox/termsofservice/url`),
            },
            privacyPolicy: {
              text: getCopyValue(
                `${baseUrlCare}/onboarding/welcome/privacy/termsandprivacycheckbox/privacypolicy/text`,
              ),
              url: getCopyValue(`${baseUrlCare}/onboarding/welcome/privacy/termsandprivacycheckbox/privacypolicy/url`),
            },
          }
        },
      },
      personalization: {
        contraindication: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/contraindication/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/contraindication/subtitle`),
        },
        name: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/name/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/name/subtitle`),
          input: {
            namePlaceholder: getCopyValue(`${baseUrlCare}/onboarding/personalization/name/input/nameplaceholder`),
            nameLabel: getCopyValue(`${baseUrlCare}/onboarding/personalization/name/input/namelabel`),
            surnamePlaceholder: getCopyValue(`${baseUrlCare}/onboarding/personalization/name/input/surnameplaceholder`),
            surnameLabel: getCopyValue(`${baseUrlCare}/onboarding/personalization/name/input/surnamelabel`),
          },
        },
        dateOfBirth: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/dateofbirth/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/dateofbirth/subtitle`),
          input: {
            placeholder: getCopyValue(`${baseUrlCare}/onboarding/personalization/dateofbirth/input/placeholder`),
            label: getCopyValue(`${baseUrlCare}/onboarding/personalization/dateofbirth/input/label`),
          },
        },
        sexOfBirth: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/sexofbirth/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/sexofbirth/subtitle`),
          male: getCopyValue(`${baseUrlCare}/onboarding/personalization/sexofbirth/male`),
          female: getCopyValue(`${baseUrlCare}/onboarding/personalization/sexofbirth/female`),
        },
        partOfBody: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/partofbody/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/partofbody/subtitle`),
        },
        pain: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/pain/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/pain/subtitle`),
          no: getCopyValue(`${baseUrlCare}/onboarding/personalization/pain/no`),
          yes: getCopyValue(`${baseUrlCare}/onboarding/personalization/pain/yes`),
        },
        degreeOfPain: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/subtitle`),
          minLabel: getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/minlabel`),
          midLabel: getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/midlabel`),
          maxLabel: getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/maxlabel`),
          painText: {
            "0": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/0`),
            "1": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/1`),
            "2": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/2`),
            "3": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/3`),
            "4": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/4`),
            "5": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/5`),
            "6": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/6`),
            "7": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/7`),
            "8": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/8`),
            "9": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/9`),
            "10": getCopyValue(`${baseUrlCare}/onboarding/personalization/degreeofpain/paintext/10`),
          },
        },
        painDuration: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/painduration/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/painduration/subtitle`),
          options: {
            acute: getCopyValue(`${baseUrlCare}/onboarding/personalization/painduration/options/acute`),
            subacute: getCopyValue(`${baseUrlCare}/onboarding/personalization/painduration/options/subacute`),
            chronic: getCopyValue(`${baseUrlCare}/onboarding/personalization/painduration/options/chronic`),
          },
        },
        coachSound: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/coachsound/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/coachsound/subtitle`),
        },
        musicPreferences: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/musicpreferences/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/musicpreferences/subtitle`),
        },
        withDiagnosis: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/withdiagnosis/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/withdiagnosis/subtitle`),
          no: getCopyValue(`${baseUrlCare}/onboarding/personalization/withdiagnosis/no`),
          yes: getCopyValue(`${baseUrlCare}/onboarding/personalization/withdiagnosis/yes`),
        },
        diagnosis: {
          title: getCopyValue(`${baseUrlCare}/onboarding/personalization/diagnosis/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/personalization/diagnosis/subtitle`),
        },
        comingSoonLabel: getCopyValue(`${baseUrlCare}/onboarding/personalization/comingsoonlabel`),
      },
      noPrescription: {
        getStarted: {
          title: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/title`),
          description: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/description`),
          cards: {
            first: {
              title: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/first/title`),
              description: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/first/description`),
            },
            second: {
              title: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/second/title`),
              description: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/second/description`),
            },
            third: {
              title: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/third/title`),
              description: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/third/description`),
            },
            fourth: {
              title: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/fourth/title`),
              description: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/cards/fourth/description`),
            },
          },
          button: getCopyValue(`${baseUrlCare}/onboarding/noprescription/getstarted/button`),
        },
      },
      therapist: {
        choose: {
          list: {
            title: getCopyValue(`${baseUrlCare}/onboarding/therapist/choose/list/title`),
            loadingTitle: getCopyValue(`${baseUrlCare}/onboarding/therapist/choose/list/loadingtitle`),
          },
          search: {
            placeholder: getCopyValue(`${baseUrlCare}/onboarding/therapist/choose/search/placeholder`),
          },
          title: getCopyValue(`${baseUrlCare}/onboarding/therapist/choose/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/therapist/choose/subtitle`),
        },
      },
      withPrescription: {
        getStarted: {
          title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/getstarted/title`),
          cards: {
            first: {
              title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/getstarted/cards/first/title`),
              description: getCopyValue(
                `${baseUrlCare}/onboarding/withprescription/getstarted/cards/first/description`,
              ),
            },
            second: {
              title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/getstarted/cards/second/title`),
              description: getCopyValue(
                `${baseUrlCare}/onboarding/withprescription/getstarted/cards/second/description`,
              ),
            },
            third: {
              title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/getstarted/cards/third/title`),
              description: getCopyValue(
                `${baseUrlCare}/onboarding/withprescription/getstarted/cards/third/description`,
              ),
            },
            fourth: {
              title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/getstarted/cards/fourth/title`),
              description: getCopyValue(
                `${baseUrlCare}/onboarding/withprescription/getstarted/cards/fourth/description`,
              ),
            },
            fifth: {
              title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/getstarted/cards/fifth/title`),
              description: getCopyValue(
                `${baseUrlCare}/onboarding/withprescription/getstarted/cards/fifth/description`,
              ),
            },
          },
        },
        upload: {
          title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/subtitle`),
          success: {
            title: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/success/title`),
            subtitle: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/success/subtitle`),
          },
          dropHere: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/drophere`),
          browse: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/browse`),
          continue: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/continue`),
          toasters: {
            sizeLimitExceeded: getCopyValue(
              `${baseUrlCare}/onboarding/withprescription/upload/toasters/sizelimitexceeded`,
            ),
            fileTypeError: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/toasters/filetypeerror`),
            uploadFailed: getCopyValue(`${baseUrlCare}/onboarding/withprescription/upload/toasters/uploadfailed`),
          },
        },
      },
      clinic: {
        preselected: {
          both: {
            title: getCopyValue(`${baseUrlCare}/onboarding/clinic/preselected/both/title`),
            subtitle: getCopyValue(`${baseUrlCare}/onboarding/clinic/preselected/both/subtitle`),
            therapist: getCopyValue(`${baseUrlCare}/onboarding/clinic/preselected/both/therapist`),
          },
          clinic: {
            title: getCopyValue(`${baseUrlCare}/onboarding/clinic/preselected/clinic/title`),
            subtitle: getCopyValue(`${baseUrlCare}/onboarding/clinic/preselected/clinic/subtitle`),
          },
        },
        choose: {
          list: {
            title: getCopyValue(`${baseUrlCare}/onboarding/clinic/choose/list/title`),
            loadingTitle: getCopyValue(`${baseUrlCare}/onboarding/clinic/choose/list/loadingtitle`),
          },
          search: {
            placeholder: getCopyValue(`${baseUrlCare}/onboarding/clinic/choose/search/placeholder`),
          },
          title: getCopyValue(`${baseUrlCare}/onboarding/clinic/choose/title`),
          subtitle: getCopyValue(`${baseUrlCare}/onboarding/clinic/choose/subtitle`),
        },
      },
      onboardingErrors: {
        unexpectedErrorTitle: getCopyValue(`${baseUrlCare}/onboarding/onboarding-errors/unexpected-error/title`),
        unexpectedErrorSubtitle: getCopyValue(`${baseUrlCare}/onboarding/onboarding-errors/unexpected-error/sub-text`),
        unexpectedErrorToast: getCopyValue(`${baseUrlCare}/onboarding/onboarding-errors/unexpected-error-toast`),
        noLongerValidCodeTitle: getCopyValue(`${baseUrlCare}/onboarding/onboarding-errors/no-longer-valid-code/title`),
        noLongerValidCodeSubtitle: getCopyValue(
          `${baseUrlCare}/onboarding/onboarding-errors/no-longer-valid-code/sub-text`,
        ),
        noLongerValidCodeToast: getCopyValue(`${baseUrlCare}/onboarding/onboarding-errors/no-longer-valid-code-toast`),
        revokedOrReusedTitle: getCopyValue(`${baseUrlCare}/onboarding/onboarding-errors/revoked-or-reused/title`),
        revokedOrReusedSubtitle: getCopyValue(`${baseUrlCare}/onboarding/onboarding-errors/revoked-or-reused/sub-text`),
      },
    },
    therapySession: {
      overtraingDialog: {
        title: getCopyValue(`${baseUrlCare}/therapysession/overtrainingdialog/title`),
        subtext: getCopyValue(`${baseUrlCare}/therapysession/overtrainingdialog/subtext`),
        takeABreak: getCopyValue(`${baseUrlCare}/therapysession/overtrainingdialog/takeabreak`),
        continue: getCopyValue(`${baseUrlCare}/therapysession/overtrainingdialog/continue`),
      },
      feedbackList: {
        title: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/title`),
        weekFilterAllOption: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/weekfilteralloption`),
        weekFilterWeekOption: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/weekfilterweekoption`),
        pending: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/pending`),
        new: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/new`),
        opened: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/opened`),
        emptyFeedbackTitle: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/emptyfeedbacktitle`),
        emptyFeedbackDescription: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/emptyfeedbackdescription`),
        newFeedbackEmptyState: {
          title: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/newfeedbackemptystate/title`),
          description: getCopyValue(`${baseUrlCare}/therapysession/feedbacklist/newfeedbackemptystate/description`),
        },
      },
      personalizedFeedback: {
        title: getCopyValue(`${baseUrlCare}/therapysession/personalizedfeedback/title`),
        card: {
          feedbackComments: getCopyValue(`${baseUrlCare}/therapysession/personalizedfeedback/card/feedbackcomments`),
        },
        emptyState: {
          title: getCopyValue(`${baseUrlCare}/therapysession/personalizedfeedback/emptystate/title`),
          description: getCopyValue(`${baseUrlCare}/therapysession/personalizedfeedback/emptystate/description`),
          image: getCopyValue(`${baseUrlCare}/therapysession/personalizedfeedback/emptystate/image`),
        },
      },
      sessionHeader: {
        session: getCopyValue(`${baseUrlCare}/therapysession/sessionheader/session`),
        week: getCopyValue(`${baseUrlCare}/therapysession/sessionheader/week`),
      },
      sessionFeedbackDetail: {
        selfReflection: {
          title: getCopyValue(`${baseUrlCare}/therapysession/sessionfeedbackdetail/selfreflection/title`),
        },
        overallFeedback: {
          title: getCopyValue(`${baseUrlCare}/therapysession/sessionfeedbackdetail/overallfeedback/title`),
        },
      },
      sessionBreakDialog: {
        title: getCopyValue(`${baseUrlCare}/therapysession/sessionbreakdialog/title`),
        subtitle: getCopyValue(`${baseUrlCare}/therapysession/sessionbreakdialog/subtitle`),
        button: getCopyValue(`${baseUrlCare}/therapysession/sessionbreakdialog/button`),
      },
      selfReflection: {
        title: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/title`),
        goBack: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/goback`),
        help: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/help`),
        subTitle: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/subtitle`),
        form: {
          stepsTitles: {
            painLevel: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/stepstitles/painlevel`),
            difficulty: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/stepstitles/difficulty`),
            feedback: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/stepstitles/feedback`),
            summary: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/stepstitles/summary`),
          },
          degreeOfPain: {
            label: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/label`),
            instruction: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/instruction`),
            minLabel: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/minlabel`),
            midLabel: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/midlabel`),
            maxLabel: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/maxlabel`),
            required: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/required`),
            gte: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/gte`),
            lte: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/lte`),
            painText: {
              "0": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/0`),
              "1": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/1`),
              "2": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/2`),
              "3": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/3`),
              "4": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/4`),
              "5": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/5`),
              "6": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/6`),
              "7": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/7`),
              "8": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/8`),
              "9": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/9`),
              "10": getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/degreeofpain/paintext/10`),
            },
          },
          painExercises: {
            label: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/painexercises/label`),
            subLabel: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/painexercises/sublabel`),
            allSelectedLabel: getCopyValue(
              `${baseUrlCare}/therapysession/selfreflection/form/painexercises/allselectedlabel`,
            ),
            required: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/painexercises/required`),
          },
          wasDifficult: {
            label: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/wasdifficult/label`),
            yes: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/wasdifficult/yes`),
            no: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/wasdifficult/no`),
          },
          difficultExercises: {
            label: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/difficultexercises/label`),
            subLabel: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/difficultexercises/sublabel`),
            required: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/difficultexercises/required`),
          },
          comments: {
            label: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/comments/label`),
            optionalLabel: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/comments/optionallabel`),
            optionalLabelStart: getCopyValue(
              `${baseUrlCare}/therapysession/selfreflection/form/comments/optional-label-start`,
            ),
            optionalLabelEnd: getCopyValue(
              `${baseUrlCare}/therapysession/selfreflection/form/comments/optional-label-end`,
            ),
            optionalLabelHyperlink: getCopyValue(
              `${baseUrlCare}/therapysession/selfreflection/form/comments/optional-label-hyperlink`,
            ),
            placeholder: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/comments/placeholder`),
          },
          reset: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/reset`),
          continue: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/continue`),
          optional: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/optional`),
          compulsory: getCopyValue(`${baseUrlCare}/therapysession/selfreflection/form/compulsory`),
        },
      },
      recap: {
        title: getCopyValue(`${baseUrlCare}/therapysession/recap/title`),
        subtitle: getCopyValue(`${baseUrlCare}/therapysession/recap/subtitle`),
        totalTime: getCopyValue(`${baseUrlCare}/therapysession/recap/totaltime`),
        totalTensionTime: getCopyValue(`${baseUrlCare}/therapysession/recap/totaltensiontime`),
        exercisesTitle: getCopyValue(`${baseUrlCare}/therapysession/recap/exercisestitle`),
        nextSession: {
          nameLabel: getCopyValue(`${baseUrlCare}/therapysession/recap/nextsession/namelabel`),
          details: getCopyValue(`${baseUrlCare}/therapysession/recap/nextsession/details`),
          durationLabel: getCopyValue(`${baseUrlCare}/therapysession/recap/nextsession/durationlabel`),
          materialLabel: getCopyValue(`${baseUrlCare}/therapysession/recap/nextsession/materiallabel`),
          tomorrow: getCopyValue(`${baseUrlCare}/therapysession/recap/nextsession/tomorrow`),
          sessionName: getCopyValue(`${baseUrlCare}/therapysession/recap/nextsession/sessionname`),
        },
        share: getCopyValue(`${baseUrlCare}/therapysession/recap/share`),
        done: getCopyValue(`${baseUrlCare}/therapysession/recap/done`),
      },
    },
  };
};

export { mapToCopyFileCare };
